import { TableBlockProps, UseServer } from '@stadionhq-v3/base-ui';
import { Theme } from '@stadionhq-v3/core';
import { TableBlock } from '@graphql/index';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import ContentfulRichTextRenderer from '@components/helpers/contentful-rich-text-render';

const tableBlockTransform = ({
  id,
  tableBlockTitle,
  introParagraph,
  tableAndBodyCopy,
  theme,
}: CleanContentful<TableBlock>): TableBlockProps => ({
  id,
  title: tableBlockTitle,
  subTitle: introParagraph,
  theme: (theme as Theme) || undefined,
  bodyCopy: (
    <UseServer>
      <ContentfulRichTextRenderer
        document={{
          json: tableAndBodyCopy?.json,
        }}
        theme={(theme as Theme) || undefined}
      />
    </UseServer>
  ),
});

export default tableBlockTransform;
